import { FilterService } from './services/filter.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MultiPickerModule } from '@shared/components/multi-picker/multi-picker.module';
import { SearchFilterWidgetV2Component } from './search-v2-filter-widget.component';
import { SearchbarFilterSaveDialogV2Component } from './searchbar-v2-filter-save-dialog.component';
import { SearchbarV2Component } from './searchbar-v2.component';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatSelectModule,
        MatOptionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMenuModule,
        MatChipsModule,
        MatIconModule,
        FormsModule,
        MatTooltipModule,
        MultiPickerModule,
        MatChipsModule
    ],
    providers: [
        FilterService,
    ],
    declarations: [
        SearchbarFilterSaveDialogV2Component,
        SearchFilterWidgetV2Component,
        SearchbarV2Component
    ],
    exports: [
        SearchFilterWidgetV2Component,
        SearchbarFilterSaveDialogV2Component,
        SearchbarV2Component,
    ]
})
export class SearchbarV2Module {
}
